import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Direktive die auf das 'change'-Event an einem <input type="file" ...> lauscht und das selektierte File als Events ausgibt.
 *
 * @author Valentin Kennke (vake@mms-dresden.de)(valentin.kennke@t-systems.com)
 */
@Directive({ selector: 'input[type=file][fileSelect]' })
export class FileSelectDirective {

    @Output() private filesSelected: EventEmitter<File[]> = new EventEmitter<File[]>();

    private element: ElementRef;

    public constructor(element: ElementRef) {
        this.element = element;
    }

    @HostListener('change')
    public onChange(): void {
        const files: File[] = Array.from(this.element.nativeElement.files);
        if (files.length > 0) {
            this.filesSelected.emit(files);
            this.element.nativeElement.value = '';
        }
    }

}
